import React, {Component} from "react";
import moment from "moment";
export default class PayStubTable extends Component {

    compare = (a, b) => {
        if ( a.key.split( 'productionDetails' )[1].replace("-", "").replace(".", "") < b.key.split( 'productionDetails' )[1].replace("-", "").replace(".", "") ){
            return -1;
        }
        if ( a.key.split( 'productionDetails' )[1].replace("-", "").replace(".", "") > b.key.split( 'productionDetails' )[1].replace("-", "").replace(".", "") ){
            return 1;
        }
        return 0;
    }

    getSortedArray = (arr) => {
        return arr.sort(this.compare);
    }

    render() {
        const { numberOfDaysWorked, earnings, formatCurrency, rawMonthlyBasePay, unFormatCurrency, mtdBillable,
            payRateOverBase, rawMonthlyBaseProduction, prodAdjWo, startDate, productionPayDetails, timeOffRequests, financialNotes, payChecks,
            contractType, doctorName, dentistWorkTimeType, patientVisits, rampOfferedDays, nonRampOfferedDays, goxTotal } = this.props;
        const bCare = unFormatCurrency(mtdBillable)
        const procBasedPay = bCare*(payRateOverBase/100);
        const firstLetter = () => {
            const firstname = this.props.user.firstname;
            return firstname ? firstname.toString().charAt(0) : "";
        };
        const lastLetter = () => {
            const lastname = this.props.user.lastname;
            return lastname ? lastname.toString().charAt(0) : "";
        }

        const percentageOfBillable = (procBasedPay/bCare)*100;
        const dailyRatePay  = (earnings/numberOfDaysWorked)
        const annualizedPay = earnings * 12;
        let fieldValue = 0;
        let fieldHeading = '';
        fieldHeading ='Base Billable Production'
        if(contractType === 'Sum Of') {
            fieldValue = rawMonthlyBaseProduction;
        } else if(contractType === 'GOX') {
            fieldValue = goxTotal;
            fieldHeading = 'GOX Total';
        } else if(contractType === 'GOZ') {
            fieldValue = goxTotal;
            fieldHeading = 'GOZ Total';
        }

        return (
            <div>
                <div className="card-body">
                    <table className="table table-bordered table">
                        <thead>
                            <tr>
                                <th colSpan={10} style={{textAlign:"center"}}>
                                    CDP Dentists Pay Summary
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className=" color-white bg-color-primary">
                                <td>Pay Month</td>
                                <td>Work Month</td>
                                <td>Work Days</td>
                                <td>Total Pay</td>
                                <td>Annualized Pay</td>
                                {contractType !== "Collections" && <td>Avg Daily Pay</td>}
                                <td>Billable Production</td>
                                <td>Work Status</td>
                                <td colSpan={2}>Selected Provider</td>
                            </tr>
                            <tr>
                                <td>{moment(startDate).add(1, 'months').format('MMMM YYYY')}</td>
                                <td>{moment(startDate).format('MMMM YYYY')}</td>
                                <td>{numberOfDaysWorked}</td>
                                <td>{contractType !=='UKG HYN'? formatCurrency(earnings):formatCurrency(0)}</td>
                                <td>{contractType !=='UKG HYN'? formatCurrency(annualizedPay):formatCurrency(0)}</td>
                                {contractType !== "Collections" && <td>{contractType !=='UKG HYN'? formatCurrency(dailyRatePay):formatCurrency(0)}</td>}
                                <td>{contractType !=='UKG HYN'? formatCurrency(unFormatCurrency(mtdBillable)):formatCurrency(0)}</td>
                                <td>{dentistWorkTimeType}</td>
                                <td colSpan={2}>{doctorName}</td>
                            </tr>
                            <tr className=" color-white bg-color-primary">
                                <td>Contract type</td>
                                {contractType !== "Collections" && <td>Ramp Work/ Offered Days</td>}
                                {contractType !== "Collections" && <td>Non-Ramp Work/ Offered Days</td>}
                                {contractType !== "Collections" && <td>Base Pay</td>}
                                {contractType !== "Collections" && <td>{fieldHeading}</td>}
                                <td> Pay %</td>
                                <td> WOADJ%</td>
                                <td> PT Vists</td>
                                <td colSpan={2}> PT Visits/ Day</td>
                            </tr>
                            <tr>
                                <td>{contractType}</td>
                                {contractType !== "Collections" && <td>{rampOfferedDays}</td>}
                                {contractType !== "Collections" && <td>{nonRampOfferedDays}</td>}
                                {contractType !== "Collections" && <td>{contractType === 'Sum Of' && formatCurrency(rawMonthlyBasePay)}</td>}
                                {contractType !== "Collections" && <td>{contractType === 'Sum Of' || contractType === 'GOX' || contractType === 'GOZ' && formatCurrency(fieldValue)}</td>}
                                <td>{(percentageOfBillable).toFixed(0)}</td>
                                <td>{prodAdjWo}</td>
                                <td>{patientVisits}</td>
                                <td colSpan={2}>{(patientVisits/numberOfDaysWorked).toFixed(0)}</td>
                            </tr>
                            <tr className="color-white bg-color-primary center">
                                <td>Requested Timeoff</td>
                                <td>Approved Requested Timeoff</td>
                                <td>Forced Timeoff</td>
                                <td>Approved Forced Timeoff</td>
                                <td>Base Work Days</td>
                            </tr>
                            {timeOffRequests}

                        </tbody>
                    </table>
                    <br />
                    {
                        payChecks && payChecks.depositDates && payChecks.depositDates.map((date, i) => <table className="table table-bordered table">
                            <thead>
                                <tr>
                                    <th colSpan={Object.values(payChecks.practice).length + 1} style={{ textAlign: "center" }}><strong>{i + 1}st Friday Pay Check- {date}</strong></th>
                                </tr>
                            </thead>
                        <tbody>
                            <tr>
                                {Object.keys(payChecks.practice).map(practice => <td>{this.props.getPracticeName(practice)}</td>)}
                                <td><b>TOTAL</b></td>
                            </tr>
                            <tr>
                                {Object.values(payChecks.practice).map(checks => <td>{formatCurrency(checks.splits[i])}</td>)}
                                <td><b>{formatCurrency(Object.values(payChecks.practice).reduce((total, curr) => (total + curr.splits[i]), 0))}</b></td>
                            </tr>
                        </tbody>
                        </table>)
                    }
                </div>

                <div className="card-body">
                    <table className="table table-bordered table">
                        <tbody>
                            <tr>
                                <th colSpan={7} style={{textAlign:"center"}}>
                                    <strong>{'Financial Notes'}</strong>
                                </th>
                            </tr>
                            <tr>
                                <th>Notes Type</th>
                                <th>Date</th>
                                <th>Title</th>
                                <th>Practice</th>
                                <th>Provider</th>
                                <th>Description</th>
                                <th>Amount</th>
                            </tr>
                        </tbody>
                        <tbody>
                            {financialNotes}
                            {financialNotes.length < 1 && (<tr key={`financialNoteRowTotal`}>
                                <td colSpan={7}><strong>No records found</strong></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>

                <div className = "card-body">
                    <table className="table table-bordered table">
                        <thead>
                            <tr>
                                    <th colSpan={10} style={{textAlign:"center"}}>
                                    <strong>{'Production Pay Details'}</strong>
                                </th>
                            </tr>
                            <tr>
                                <th>Proc Date</th>
                                <th>Practice</th>
                                <th>Gross Production</th>
                                <th>Office Adjustment</th>
                                <th>Write Off</th>
                                {contractType === 'GOX' && <th>GOX</th>}
                                {contractType === 'GOZ' && <th>GOZ</th>}
                                {contractType === "Collections" && <th>Collections</th>}
                                <th>Billable Production</th>
                                <th>Financial Notes </th>
                                <th>Total Pay </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getSortedArray(productionPayDetails)}
                            {productionPayDetails.length < 1 && (<tr key={`productionPayDetailsRowTotal`}>
                                <td colSpan={5}><strong>No records found</strong></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <div style={{display: 'flex',"justify-content": 'center',"align-items": 'center'}}> {moment().format('DD-MMMM-YYYY-hh:mmA')+`-${firstLetter()}`+`${lastLetter()}`}</div>
            </div>
        )
    }
}
